import { Modal as BootstrapModal } from 'react-bootstrap'
import styled from 'styled-components'
import { theme } from '@aserto/console-common'

type HeaderVariant = 'standard' | 'success'

const StyledHeader = styled(BootstrapModal.Header)<{ variant?: HeaderVariant }>`
  background-color: ${({ variant, theme }) =>
    variant === 'success' ? theme.apple50 : theme.grey20};
  border: none;
  padding: 20px;
`

const StyledTitle = styled(BootstrapModal.Title)`
  font-size: 20px;
  font-weight: 500;
  color: ${theme.grey100};
`

const StyledBody = styled(BootstrapModal.Body)`
  background-color: ${theme.grey10};
  padding: 20px;
`

const StyledFooter = styled(BootstrapModal.Footer)`
  background-color: ${theme.grey10};
  border: none;
`

const Modal = Object.assign(styled(BootstrapModal).attrs({ centered: true })``, {
  Header: StyledHeader,
  Title: StyledTitle,
  Body: StyledBody,
  Footer: StyledFooter,
})
export default Modal
